import { useCallback, useEffect, useState } from 'react';
import { NotebookPen } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { t } from '../i18n/nl.js';

function formatDateTime(value) {
  return new Intl.DateTimeFormat('nl-NL', {
    timeZone: 'Europe/Amsterdam', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  }).format(new Date(value));
}

export default function ClientNotesPanel({ clientId }) {
  const { user } = useAuth();
  const { showSuccess, showError } = useToast();
  const [notes, setNotes] = useState([]);
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const { data, error } = await supabase.from('client_notes')
      .select('id, body, created_at, author:profiles!client_notes_author_id_fkey(full_name)')
      .eq('client_id', clientId).order('created_at', { ascending: false }).order('id', { ascending: false });
    if (error) showError(t('clientNotes.loadError') + error.message);
    setNotes(data || []);
    setLoading(false);
  }, [clientId, showError]);

  useEffect(() => { load(); }, [load]);

  async function submit(event) {
    event.preventDefault();
    if (!body.trim()) return;
    setSaving(true);
    const { error } = await supabase.from('client_notes').insert({ client_id: clientId, author_id: user.id, body: body.trim() });
    setSaving(false);
    if (error) { showError(t('clientNotes.saveError') + error.message); return; }
    setBody('');
    await load();
    showSuccess(t('clientNotes.saved'));
  }

  return (
    <section className="client-notes-section">
      <div className="client-notes-heading"><NotebookPen size={17} /><h3>{t('clientNotes.title')}</h3></div>
      <form className="client-notes-form" onSubmit={submit}>
        <textarea className="form-input" rows="3" maxLength={4000} value={body} onChange={event => setBody(event.target.value)} placeholder={t('clientNotes.placeholder')} />
        <button className="btn btn-primary btn-sm" disabled={saving || !body.trim()}>{saving ? t('common.laden') : t('clientNotes.add')}</button>
      </form>
      <div className="client-notes-list">
        {loading ? <span className="spinner" /> : notes.length === 0 ? <p>{t('clientNotes.empty')}</p> : notes.map(note => (
          <article key={note.id}><p>{note.body}</p><small>{note.author?.full_name || t('clientNotes.unknownAuthor')} · {formatDateTime(note.created_at)}</small></article>
        ))}
      </div>
    </section>
  );
}
